(function () {
  angular.module("ticketco/common/section").directive("tcSection", function () {
    return {
      restrict: "E",
      require: "ngModel",
      scope: {
        selected: "=ngModel",
      },
      link: function (scope, element, attrs, ngModelCtrl) {
        scope.selected = scope.selected || [];

        $(element).on("seat:selectionChanged", function (_, data) {
          ngModelCtrl.$setViewValue(data);
        });

        scope.$watchCollection("selected", function (newValue, oldValue) {
          if (R.equals(newValue, oldValue)) return;
          var sectionController = $(element).data().instance;
          var selectionDifference = R.differenceWith(function (a, b) {
            return a.row + "-" + a.seat === b.row + "-" + b.seat;
          });
          var newlyAdded = selectionDifference(newValue, oldValue);
          var removedItems = selectionDifference(oldValue, newValue);

          newlyAdded.forEach(function (x) {
            sectionController.selectSeat(x.row, x.seat);
          });

          removedItems.forEach(function (x) {
            sectionController.deselectSeat(x.row, x.seat);
          });
        });
      },
    };
  });
})();
